import React from 'react';
import {SideMenuProps} from './types';
import styled from 'styled-components';
import {COLORS, ComponentLStyling, ComponentMStyling, ComponentSStyling, ComponentTextStyle} from '../styles';
import {IconButton} from '../Button';
import {SystemIcons} from '../icons';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0 8px;

  .small & {
    min-height: 48px;
  }

  .medium & {
    min-height: 56px;
  }

  .large & {
    min-height: 64px;
  }
`;

const LabelContainer = styled.div`
  margin-left: 8px;

  .small & {
    ${ComponentSStyling(ComponentTextStyle.Bold, COLORS.neutral_600)}
  }

  .medium & {
    ${ComponentMStyling(ComponentTextStyle.Bold, COLORS.neutral_600)}
  }

  .large & {
    ${ComponentLStyling(ComponentTextStyle.Bold, COLORS.neutral_600)}
  }
`;

export const SideMenuHeader = (props: SideMenuProps) => {

  return (
    <Wrapper>
      {
        props.header?.actions?.map(({icon, ...rest}, index) =>
          <IconButton key={index} variant={'secondary'} shape={'circular'} {...rest}>
            {icon}
          </IconButton>
        )
      }
      {
        props.header?.label &&
        <LabelContainer>
          {props.header.label}
        </LabelContainer>
      }
      <IconButton action={props.onClose} variant={'secondary'} shape={'circular'} style={{marginLeft: 'auto'}}>
        <SystemIcons.Close/>
      </IconButton>
    </Wrapper>
  )
};
